module.exports = __webpack_public_path__ + "res/33-img_bg_l.8f3bb90f5f825649132d674776ba2380.png";